/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useAuthContext } from "../../contexts/AuthContext";
import { useSessionContext } from "../../contexts/SessionContext";
import { RefreshTokenGoogle } from "@/services/google/RefreshTokenGoogle";
import Features from "./Features";

import { PrivateMainLayout } from "@/components/layout";
import { PrivateMainLayoutV2 } from "@/components/layout/private/main/PrivateMainLayoutV2";
import { isMobile } from "react-device-detect";
import { currentFeatures } from "@/configs/Settings";
import FluxVetApplication from "@/fluxvet/components/FluxVetApplication";

/**
 * @description Componente que gerencia a lógica de renovação de tokens e sessão do usuário
 * @returns JSX.Element
 */
export function LoggedUserContent() {
  const { parsedTime, logoutUser, getNewToken } = useAuthContext();
  const { user, setAccessTokenGoogle } = useSessionContext();

  /**
   * Flag simples para habilitar o layout V2 (refatorado) sem quebrar o legado.
   *
   * Como ativar:
   * - no DevTools console: `localStorage.setItem("enableLegacyLayoutV2", "true")`
   * - recarregar a página
   */
  const isLegacyLayoutV2Enabled = true;

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (Date.now() >= parsedTime || !parsedTime) {
        logoutUser();
      } else if (Date.now() >= parsedTime - 15 * 60 * 1000) {
        getNewToken();
        if (user?.refreshTokenGoogle) {
          (async () => {
            try {
              const refreshToken = await RefreshTokenGoogle(
                user.refreshTokenGoogle,
              );
              setAccessTokenGoogle(refreshToken.access_token);
            } catch (error) {
              console.error("Erro ao renovar token do Google:", error);
            }
          })();
        }
        toast.success("Sessão renovada");
      }
    }, 60000);

    return () => clearInterval(intervalId);
  }, [parsedTime]);

  return (
    <>
      {isLegacyLayoutV2Enabled ? (
        <PrivateMainLayoutV2>
          <Features />
        </PrivateMainLayoutV2>
      ) : (
        <PrivateMainLayout noSidebar={isMobile}>
          <Features />
        </PrivateMainLayout>
      )}
    </>
  );
}
